import * as React from 'react';
import { DataEntry } from 'react-minimal-pie-chart/types/commonTypes';
import styled from 'styled-components';
import { PanelContext } from '../../components_v2/panel/context';
import { DefaultButton } from '../../styles/global/css/GlobalButton';
import { SurfaceColor } from '../../styles/global/css/Utils';
import { Translate } from '../../styles/global/translate';

const ToolTipContainer = styled.div<{ up?: boolean, cluster?: boolean }>`
	position: relative;
	z-index: 1;
	width: fit-content;
	padding: 7px 15px;
	-- transform: ${p => p.up ? 'translate(calc(-50% - 4px), calc(-100% - 22px))' : `translate(calc(-100% - 25px), ${p.cluster ? '-50%' : 'calc(-50% - 13px)'})`};
	transform: unset;
	${p => p.up ? `
		translate: -50% calc(-100% - 10px);
  		left: 50%;
  		top: -100%;
	` : `
		top: -50%;
		translate: calc(-100% - 10px) -50%;
	`}
	font-size: 11px;
	&:after {
		content: " ";
		position: absolute;
		${p => p.up ? 'top' : 'left'}: 100%;
		${p => p.up ? 'left' : 'top'}: 50%;
		margin-${p => p.up ? 'left' : 'top'}: -5px;
		border-width: 5px;
		border-style: solid;
		border-color: ${p => p.up ? SurfaceColor : 'transparent'} transparent transparent ${p => p.up ? 'transparent' : SurfaceColor};
	}
	p {
		margin: 0;
		font-size: 10px;
		color: white;
		text-wrap: nowrap;
	}
`;

export default function MapToolTip(props: {
	data?: DataEntry[],
	instore?: boolean,
	title?: string,
	night?: boolean,
	up?: boolean,
	children?: React.ReactNode,
	cluster?: boolean,
	subTitle?: string,
	companyId?: number
}) {
	const { data, instore, title, subTitle } = props;
	const { calendarViewState } = React.useContext(PanelContext);

	return (
		(<ToolTipContainer className='description-tooltips trash show-on-hover' up={props.up} cluster={props.cluster}>
			{title && <span className='font-weight-bold' style={{ marginBottom: '2px', whiteSpace: 'nowrap' }}>
				{title}
			</span>}
			<div>
				{subTitle}
			</div>
			<table>
				<tbody>
					{data?.map((d, i) =>
						<tr key={`mapToolTipValue${i}`}>
							<td style={{ textAlign: 'right', padding: '0px', paddingRight: 10, whiteSpace: 'nowrap' }}>
								{d.label}
							</td>
							<td style={{ textAlign: 'center', padding: '0px', paddingRight: 10 }}>
								<span className='dot' style={{ backgroundColor: d.color }} />
							</td>
							<td style={{ textAlign: 'left', padding: '0px' }}>
								<span>{instore ? `${d.value.toFixed(2).replace(/(\.0+|0+)$/, '')}%` : d.value}</span>
							</td>
						</tr>
					)}
				</tbody>
			</table>
			{props.children}
			{!props.cluster && props.companyId !== undefined && <CalendarButton onClick={(e) => {
				const [_, setModalState] = calendarViewState.eventModalHook;
				setModalState({ isOpen: true, data: { defaultValues: { clientCompanyId: props.companyId } } });
				e.preventDefault();
				e.stopPropagation();
			}}>
				<p>
					<Translate id='general.event' />
				</p>
			</CalendarButton>}
		</ToolTipContainer>)
	);
}

const CalendarButton = styled(DefaultButton)`
	margin: 5px 0 0 0;
  	height: 25px;
   	width: 100%;
  `;
